/**
 * Discovery-date display/export format for the inventory table. Always shows the full year — unlike
 * the review-date column, which switches format based on the current year (getDateFormat). Discovery
 * date is historical reference data, so the year is always relevant. Shared by the table cell and the
 * CSV export so the two never drift.
 */
export const DISCOVERY_DATE_FORMAT = 'MMM dd, yyyy';
